export default __webpack_public_path__ + "static/media/has-on-site-disabled.2da24fcc.svg";